const n = (n2) => "range" in n2 ? null != (n2 == null ? void 0 : n2.range) : null != (n2 == null ? void 0 : n2.value);
export {
  n as hasItemValue
};
//# sourceMappingURL=hasItemValue.js.map
